import _get from 'lodash/get'
import qs from 'qs'
import apiWrapper from '@/utils/apiHelpers/apiWrapper'
import Landing from '@/components/landing'
import { getInitialStoreSetup } from '@/store/helpers/storeHelpers'
import { pageActions } from '@/store/page'
import { searchActions } from '@/store/search'
import { reduxWrapper } from '@/store'
import { withLogger } from '@/utils/logger'

export const getServerSideProps = reduxWrapper.getServerSideProps(store =>
  withLogger(async ctx => {
    const { vin, language } = ctx.query
    const { brand: selectedBrand } = await getInitialStoreSetup({
      store,
      ctx
    })
    const filters = _get(store.getState(), 'search.query.filterBy')
    if (!vin) {
      if (_get(filters, 'year')) store.dispatch(searchActions.UPDATE_FILTERS({ ...filters, year: '' }))
      store.dispatch(pageActions.SET_TITLE(null))
      return {}
    }

    let findCriteriaByVinUrl = `publications/findCriteriaByVin/${vin}`
    if (selectedBrand) findCriteriaByVinUrl += `/${selectedBrand.toUpperCase()}`
    const result = await apiWrapper.get(findCriteriaByVinUrl)

    if (!result.success) {
      return { redirect: { destination: '/404', permanent: false } }
    }

    const {
      brand,
      model,
      modelType,
      ngtdModelId,
      katashiki,
      productionDate,
      dateFrom,
      dateTo,
      generationId,
      availableLanguagesCodes
    } = result.response

    const query = {
      brand,
      model,
      modelType,
      ngtdModelId,
      katashiki,
      productionDate,
      dateFrom,
      dateTo,
      generationId,
      language,
      isInApp: true
    }

    const hasLanguage = availableLanguagesCodes.includes(language)
    const publicationsQuery = hasLanguage ? query : { ...query, language: 'en' }
    const redirectUrl = `/publications?${qs.stringify(publicationsQuery)}`

    return { redirect: { destination: redirectUrl, permanent: false } }
  })
)

const LandingPage = props => <Landing {...props} />

export default LandingPage
